import type { DoraRisk } from './doraRisk.ts';
import type { DoraFinding } from './doraFinding.ts';
import { isNumber } from './utils.ts';

export interface DoraControl {
  id?: number;
  name: string;
  description?: string | null;
  control_type?: string | null;
  risks?: DoraRisk[];
  findings?: DoraFinding[];
}

export type DoraControlUpdate = Partial<Omit<DoraControl,
  'id' |
  'risks' |
  'findings'
>> & {
  risk_ids?: number[];
};

export const doraControlToUpdate = ({ id, risks, findings, ...rest }: DoraControl): DoraControlUpdate => ({
  ...rest,
  risk_ids: risks?.map(risk => risk.id).filter(isNumber),
});
